<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t("add") }} {{ $t("ratecard") }}</div>
      <router-link class="btn-blue" to="rateCard"
        >{{ $t("ratecard") }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selectedCinema.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Cinema"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema($event.target.value)"
                    v-on:keydown="onSearchCinema($event.target.value)"
                    v-on:search="onSearchCinema($event.target.value)"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in cinemaList"
                  :key="dropdownIndex"
                  href="#"
                  @click="onDropdownChange($event, dropdownItem)"
                  >{{ dropdownItem.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('rateCard_Cinema')" />
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedCinema.length == 0">{{
                $t("pleaseSelectCinema")
              }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="ratecard.rc_name"
                type="text"
                name="ratename"
                id="ratename"
                v-validate="{ required: 'required', regex: '[a-zA-Z0-9\\ ]' }"
              />
              <label>{{ $t("ratecard") }} {{ $t("name") }}</label>
            </div>
            <Tooltip :title="$t('rateCard_RateCardName')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('ratename')">{{
              errors.first("ratename")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="selectedChargeSettingName.length > 0 ? 'shift-up' : ''"
              >{{ $tc("chargesettingname", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedChargeSettingName"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search Settings"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchSetting($event.target.value)"
                    v-on:keydown="onSearchSetting($event.target.value)"
                    v-on:search="onSearchSetting($event.target.value)"
                    v-model="searchSetting"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in pas_setting_name_list"
                  :key="dropdownIndex"
                  href="#"
                  @click="onChangeSettingName($event, dropdownItem)"
                  >{{ dropdownItem.pas_charge_setting_name }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('rateCard_ChargeSettingName')" />
            </div>
            <p class="error_message">
              <span v-if="submitted && selectedChargeSettingName.length == 0">{{
                $t("pleaseSelectChargeSettingName")
              }}</span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="ratecard.rc_amount"
                v-on:keyup="onChangeRatecardAmount($event)"
                type="text"
                name="rateamount"
                id="rateamount"
                v-validate="'required|decimal'"
              />
              <label>{{ $t("amount") }}</label>
            </div>
            <Tooltip :title="$t('rateCard_Amount')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('rateamount')">{{
              errors.first("rateamount")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="selectedItem && selectedItem.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $t("fnbitem") }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selectedItem"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    placeholder="Search F&B Item"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchItem($event.target.value)"
                    v-on:keydown="onSearchItem($event.target.value)"
                    v-on:search="onSearchItem($event.target.value)"
                    v-model="searchItem"
                  />
                </div>
                <b-dropdown-item
                  v-for="(dropdownItem, dropdownIndex) in fnbItems"
                  :key="dropdownIndex"
                  href="#"
                  @click="onDropdownFnBItem($event, dropdownItem)"
                  >{{ dropdownItem.item_name }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('rateCard_fnb')" />
              <!-- <button
                v-if="selectedItem"
                @click="resetFnbItem"
                class="btn-blue c-pointer"
              >
                {{ $t("clear") }}
              </button> -->
              <img
                v-if="selectedItem"
                src="@/assets/img/icons/delete-red-light.svg"
                alt="Clear"
                class="c-pointer"
                @click="resetFnbItem"
                width="24"
              />
            </div>
            <p class="error_message">
              <span
                v-if="
                  submitted &&
                  ratecard.item_is_compulsory &&
                  selectedItem.length == 0
                "
                >Please Select F&B Item.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="internet_handling_fee_label"
                @input="OnInternethandlingChange($event)"
                type="text"
                name="internetHandlingFees"
                id="internetHandlingFees"
              />
              <label>{{ $t("internetHandlingFees") }}</label>
            </div>
            <Tooltip :title="$t('internetHandlingFees')" />
          </div>
          <p class="error_message">
            <span v-if="internet_handling_is_percentage"
              >Final Fees are {{ ratecard.internet_handling_fee }}</span
            >
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">{{ $t("inclusivoftax") }}</label>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              v-model="ratecard.rc_is_active_inclusivtax"
              name="check-button"
              @change="OnSwitchHandler($event)"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">({{$t("online_fee")}})&nbsp;{{ $t("isPercentageofGross") }} </label>
            <b-form-checkbox
              :unchecked-value="false"
              :value="true"
              v-model="internet_handling_is_percentage"
              name="check-button-internethandling-fee"
              @change="OnInternethandlingSwitchHandler($event)"
              switch
            ></b-form-checkbox>
          </div>
        </div>

        <!-- <div class="col-lg-4 col-xl-2 align-self-center mb-5">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3"
              >{{ $t("item") }} {{ $t("compulosry") }}</label
            >
            <b-form-checkbox
              v-model="ratecard.item_is_compulsory"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>
        </div> -->

        <div class="col-md-12">
          <!-- <div>
            <div class="font-weight-bold mb-2">
              {{ $t("add") }} {{ $tc("charge", 2) }}
            </div>
          </div> -->
          <div v-if="list.length > 0">
            <span class="font-weight-bold text-blue fs-16">Tax Structure</span>
            <table class="swc-report-table mb-3" border="1">
              <thead>
                <tr>
                  <th>{{ $t("Tax Name") }}</th>
                  <th>{{ $t("Tax Value") }}</th>
                  <th class="text-right">{{ $t("Total Tax") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(cinemaCharge, cinemaChargesListIndex) in list"
                  :key="cinemaChargesListIndex"
                >
                  <td>{{ cinemaCharge.ct_name }}</td>
                  <td>
                    {{ cinemaCharge.pas_charge_value
                    }}{{ cinemaCharge.pas_is_percentage == "Y" ? "%" : "" }}
                  </td>
                  <td class="text-right">
                    {{ currencyData.curr_code }}&nbsp;{{
                      cinemaCharge.pas_is_rebate === "Y"
                        ? "-" +
                          parseFloat(cinemaCharge.cinemacharges).toFixed(3)
                        : parseFloat(cinemaCharge.cinemacharges).toFixed(3)
                    }}
                    <template
                      v-if="
                        cinemaCharge.pas_is_rebate === 'N' &&
                        cinemaCharge.pas_is_taxable == 'Y' &&
                        cinemaCharge.pas_is_percentage == 'N'
                      "
                      >(tax ={{ totalTaxPercentage }} |
                      {{
                        parseFloat(
                          (cinemaCharge.cinemacharges * totalTaxPercentage) /
                            100
                        ).toFixed(3)
                      }})</template
                    >
                    <template
                      v-if="
                        cinemaCharge.pas_is_rebate === 'N' &&
                        cinemaCharge.pas_is_taxable == 'Y' &&
                        cinemaCharge.pas_is_percentage == 'Y'
                      "
                      >(tax =
                      {{
                        Math.round(
                          (cinemaCharge.pas_charge_value *
                            ratecard.rc_net_amount *
                            totalTaxPercentage) /
                            100
                        ) / 100
                      }})</template
                    >
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <span class="font-weight-bold text-center"
                      >Applicable Tickets Tax</span
                    >
                  </td>
                  <td colspan="1" class="text-right font-weight-bold">
                    {{ currencyData.curr_code }}&nbsp;{{
                      parseFloat(
                        ratecard.rc_total_amount - ratecard.rc_net_amount
                      ).toFixed(3)
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row totalCalculations">
            <div class="col-md-12">
              <div class="row w-25 float-right">
                <span class="col-6 font-weight-bold">Net Amount:</span>
                <span class="col-6 text-right"
                  >{{ currencyData.curr_code }}
                  {{ ratecard.rc_net_amount.toFixed(3) }}</span
                >
              </div>
            </div>
            <div class="col-md-12">
              <div class="row w-25 float-right">
                <span class="col-6 font-weight-bold">Tax (Tickets):</span>
                <span class="col-6 text-right"
                  >{{ currencyData.curr_code }}&nbsp;{{
                    parseFloat(
                      ratecard.rc_total_amount - ratecard.rc_net_amount
                    ).toFixed(3)
                  }}</span
                >
              </div>
            </div>

            <div
              class="col-12"
              v-if="false"
              v-for="(cinemaCharge, cinemaChargesListIndex) in list"
              :key="cinemaChargesListIndex"
            >
              <div class="row">
                <!-- IMAGE DIMENSION -->
                <div class="col-md-5 mb-4">
                  <div class="d-flex align-items-center">
                    <div class="input-material">
                      <!-- <input v-model="cinemaCharge.rc_name" type="text" required="required" /> -->
                      <label>{{ cinemaCharge.ct_name }}</label>
                    </div>
                  </div>
                  <!-- <p class="error_msg">Invalid Entry</p> -->
                </div>

                <div class="col-md-7">
                  <div class="row">
                    <div class="col-md-5">
                      <div
                        class="
                          d-flex
                          justify-content-center
                          align-items-center
                          p-3
                        "
                      >
                        <label
                          >{{ cinemaCharge.pas_charge_value
                          }}{{
                            cinemaCharge.pas_is_percentage == "Y" ? "%" : ""
                          }}</label
                        >
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div
                        class="
                          d-flex
                          justify-content-center
                          align-items-center
                          p-3
                        "
                      >
                        <label>
                          {{
                            cinemaCharge.pas_is_rebate === "Y"
                              ? "-" + cinemaCharge.cinemacharges
                              : cinemaCharge.cinemacharges
                          }}
                          <template
                            v-if="
                              cinemaCharge.pas_is_rebate === 'N' &&
                              cinemaCharge.pas_is_taxable == 'Y' &&
                              cinemaCharge.pas_is_percentage == 'N'
                            "
                            >(tax ={{ totalTaxPercentage }} |
                            {{
                              parseFloat(
                                (cinemaCharge.cinemacharges *
                                  totalTaxPercentage) /
                                  100
                              ).toFixed(3)
                            }})</template
                          >
                          <template
                            v-if="
                              cinemaCharge.pas_is_rebate === 'N' &&
                              cinemaCharge.pas_is_taxable == 'Y' &&
                              cinemaCharge.pas_is_percentage == 'Y'
                            "
                            >(tax =
                            {{
                              Math.round(
                                (cinemaCharge.pas_charge_value *
                                  ratecard.rc_net_amount *
                                  totalTaxPercentage) /
                                  100
                              ) / 100
                            }})</template
                          >
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-12 mb-2" v-if="selectedFnbItem">
              <div class="row w-25 float-right">
                <span class="col-6 font-weight-bold">Ticket Total:</span>
                <span class="col-6 text-right font-weight-bold"
                  >{{ currencyData.curr_code }}
                  {{ ratecard.rc_total_amount.toFixed(this.MIN_FRACTION_DIGITS) }}</span
                >
              </div>
            </div>

            <div class="col-md-12" v-if="selectedFnbItem">
              <div class="row w-25 float-right">
                <span class="col-6 font-weight-bold">F&B Item Net Amount:</span>
                <span class="col-6 text-right"
                  >{{ currencyData.curr_code }}
                  {{
                    selectedFnbItem.fp_amount &&
                    parseInt(selectedFnbItem.fp_amount)
                      ? selectedFnbItem.fp_amount.toFixed(this.MIN_FRACTION_DIGITS)
                      : "0.00"
                  }}</span
                >
              </div>
            </div>
            <div class="col-md-12" v-if="selectedFnbItem">
              <div class="row w-25 float-right">
                <span class="col-6 font-weight-bold">F&B Taxes:</span>
                <span class="col-6 text-right"
                  >{{ currencyData.curr_code }}
                  {{
                    selectedFnbItem.fp_total_amount !== null &&
                    selectedFnbItem.fp_amount !== null &&
                    parseInt(selectedFnbItem.fp_total_amount) &&
                    parseInt(selectedFnbItem.fp_amount)
                      ? (
                          selectedFnbItem.fp_total_amount -
                          selectedFnbItem.fp_amount
                        ).toFixed(this.MIN_FRACTION_DIGITS)
                      : "0.00"
                  }}</span
                >
              </div>
            </div>
            <div class="col-md-12 mb-2" v-if="selectedFnbItem">
              <div class="row w-25 float-right">
                <span class="col-6 font-weight-bold">F&B Total:</span>
                <span class="col-6 text-right font-weight-bold"
                  >{{ currencyData.curr_code }}
                  {{
                    selectedFnbItem.fp_total_amount !== null &&
                    parseInt(selectedFnbItem.fp_total_amount)
                      ? selectedFnbItem.fp_total_amount.toFixed(this.MIN_FRACTION_DIGITS)
                      : "0.00"
                  }}</span
                >
              </div>
            </div>
            <div class="col-md-12 mb-2" v-if="false">
              <div class="col-lg-3 col-xl-3 align-self-center mb-4">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="ratecard.reports_only_fee_label"
                      type="text"
                      name="reportsOnlyFeeName"
                      id="reportsOnlyName"
                    />
                    <label>{{ $t("reportsOnlyFeeLabel") }}</label>
                  </div>
                  <Tooltip :title="$t('reportsOnlyFeeLabel')" />
                </div>
              </div>
              <div class="col-lg-3 col-xl-3 align-self-center mb-4">
                <div class="d-flex align-items-center">
                  <div class="input-material">
                    <input
                      placeholder="."
                      v-model="ratecard.reports_only_fee_value"
                      type="text"
                      name="reportsOnlyFeeValue"
                      id="reportsOnlyValue"
                    />
                    <label>{{ $t("reportsOnlyFeeValue") }}</label>
                  </div>
                  <Tooltip :title="'Reports only fee value'" />
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="row w-25 float-right totalborder">
                <span class="col-6 font-weight-bold fs-16">Gross Total:</span>
                <span class="col-6 text-right font-weight-bold"
                  >{{ currencyData.curr_code }}
                  {{
                    (
                      ratecard.rc_total_amount +
                      (selectedFnbItem &&
                      selectedFnbItem.fp_total_amount &&
                      parseInt(selectedFnbItem.fp_total_amount)
                        ? selectedFnbItem.fp_total_amount
                        : 0)
                    ).toFixed(this.MIN_FRACTION_DIGITS)
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="rateCard">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>
    <b-modal
      id="zeroRateCardAmountModal"
      hide-footer
      hide-header
      no-close-on-backdrop
    >
      <button
        class="btn-modal-close"
        style="top: 15px; right: 15px; position: absolute; z-index: 99"
        @click="CloseModal(`zeroRateCardAmountModal`)"
      >
        &times;
      </button>
      <label class="h4 mt-2 mb-4 text-center"
        >Are you sure you want to proceed with the 0 value ticket ?</label
      >
      <br />
      <div class="text-center">
        <button
          class="btn-blue"
          @click.prevent.stop="
            () => {
              accepted_zero_rate_card_popup = true;
              OnFinalSubmit(true);
            }
          "
        >
          Yes
        </button>
        <button
          class="btn-blue text-right"
          @click.prevent.stop="CloseModal(`zeroRateCardAmountModal`)"
        >
          No
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";

export default {
  data() {
    return {
      btenable: false,
      isRoleID: true,
      submitted: false,
      storecurrencyid: "",
      searchCinema: "",
      searchSetting: "",
      searchItem: "",
      // Saif
      cinemaList: [],
      cinemaListCopy: [],
      currencyData: [],
      selectedCinema: "",
      selectedItem: "",
      fnbItems: [],
      fnbItemsCopy: [],
      cinemaChargesList: [],
      cinemaChargesListCopy: [],
      selectedChargeSettingName: "",
      pas_setting_name_list: [],
      pas_setting_name_listCopy: [],
      internet_handling_is_percentage: false,
      internet_handling_fee_label: 0,
      ratecard: {
        cinema_id: null,
        rc_name: "",
        rc_amount: "",
        currency_id: null,
        rc_is_active_inclusivtax: "Y",
        rc_net_amount: 0,
        rc_total_amount: 0,
        item_id: null,
        item_is_compulsory: false,
        accepted_zero_rate_card_popup: false,
        internet_handling_fee: 0,
        reports_only_fee_label: "",
        reports_only_fee_value: 0,
      },
      totalTaxPercentage: 0,
      selectedFnbItem: 0,
      // Saif
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }

    this.getGlobalOptions();
    this.getCinemaList(obj);
    this.getCurrencyCode();
    this.getFnBItems();
  },
  mounted() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onDropdownChange(null, CinemaObj);
    }
  },
  computed: {
    list() {
      return this.cinemaChargesList;
    },
  },
  methods: {
    CloseModal(modal_name) {
      this.$bvModal.hide(modal_name);
    },

    onSearchCinema: function (value) {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.cinemaList = this.cinemaListCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.cinemaList = this.cinemaListCopy;
      }
    },
    onSearchItem: function (value) {
      if (this.searchItem && this.searchItem.length > 0) {
        this.fnbItems = this.fnbItemsCopy.filter((x) => {
          if (
            x.item_name.toLowerCase().includes(this.searchItem.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.fnbItems = this.fnbItemsCopy;
      }
    },
    onSearchSetting: function (value) {
      if (this.searchSetting && this.searchSetting.length > 0) {
        this.pas_setting_name_list = this.pas_setting_name_listCopy.filter(
          (x) => {
            if (
              x.pas_charge_setting_name
                .toLowerCase()
                .includes(this.searchSetting.toLowerCase())
            ) {
              return x;
            }
          }
        );
      } else {
        this.pas_setting_name_list = this.pas_setting_name_listCopy;
      }
    },
    getCurrencyCode: function () {
      let payload = {
        tableName: "ms_currencies",
        curr_is_active: "Y",
        curr_id:
          this.secureStore.get("BRGLOPCU") &&
          this.secureStore.get("BRGLOPCU").go_value,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.currencyData = data.Records[0];
          } else {
            // this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getFnBItems: function () {
      let body = {
        tableName: "fnb_items",
        item_is_active: "Y",
        rate_card_flag: true,
        with_prices: true,
      };
      MasterService.GetActiveList(body)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.fnbItems = data.Records;
              this.fnbItemsCopy = data.Records;
            }
            // else {
            //   this.$toasted.show(data.message);
            // }
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch(this._CatchError);
    },
    onDropdownFnBItem: function (event, value) {
      this.ratecard.item_id = value.item_id;
      this.selectedItem = value.item_name;
      this.selectedFnbItem = value;
    },
    resetFnbItem: function () {
      this.ratecard.item_id = "";
      this.selectedItem = "";
      this.selectedFnbItem = "";
    },
    // Saif
    resetForm: function () {
      this.selectedCinema = "";
      this.selectedChargeSettingName = "";
      this.selectedItem = "";
      this.ratecard = {
        rc_name: "",
        rc_amount: "",
        currency_id: this.storecurrencyid,
        rc_is_active_inclusivtax: "Y",
        rc_net_amount: 0,
        rc_total_amount: 0,
        item_id: null,
        item_is_compulsory: false,
      };
      // this.getGlobalOptions();
      this.cinemaChargesList = [];
    },
    getGlobalOptions: function () {
      MasterService.GetGlobalOptions()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            data.Records.map((x) => {
              if (x.go_key === "CURRENCY") {
                this.ratecard.currency_id = x.go_value || null;
                this.storecurrencyid = x.go_value || null;
                // console.log(this.ratecard.currency_id);
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getCinemaList: function (cine_id) {
      // let body = {
      //   activekey: "cine_is_active"
      // };
      // MasterService.GlobalRequest(body)
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
            this.cinemaListCopy = data.Records;
            this.cinemaList.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                // this.selectedCinema = x.cine_name;
                // this.getPasSettingName(x.cine_id);
                this.onDropdownChange(null, {
                  cine_name: x.cine_name,
                  cine_id: x.cine_id,
                });
                // this.OnSelectCinema(event, x.cine_id, x.cine_name)
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getCinemaCharges: function (id) {
      this.cinemaChargesList = [];
      let payload = {
        pas_charge_setting_name: this.selectedChargeSettingName,
        id: id,
      };
      CinemasService.GetCinemaChargesByCinemaId(payload)
        .then(async (response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinemaChargesList = data.Records;
            this.cinemaChargesListCopy = data.Records;
            let promises = this.cinemaChargesList.map((x) => {
              x["cinemacharges"] = 0;
              return x;
            });
            await Promise.all(promises).then(() => {
              this.cinemaChargesCalculation();
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    // On click and Change Handler
    onDropdownChange: function (event, item) {
      this.selectedCinema = item.cine_name;
      this.ratecard.cinema_id = item.cine_id;
      // this.getCinemaCharges(item.cine_id);
      this.getPasSettingName(item.cine_id);
    },
    getPasSettingName: function (id) {
      this.pas_setting_name_list = [];
      CinemasService.GetCinemaSettingNameByCinemaId({ id })
        .then(async (response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.pas_setting_name_list = data.Records;
            this.pas_setting_name_listCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    onChangeSettingName: function (event, item) {
      this.selectedChargeSettingName = item.pas_charge_setting_name;
      this.getCinemaCharges(this.ratecard.cinema_id);
    },
    OnSwitchHandler: function (event) {
      this.ratecard.rc_is_active_inclusivtax = event;
      this.cinemaChargesCalculation();
    },
    OnInternethandlingChange: function (event) {
      let amount = parseFloat(event.target.value);
      if (this.internet_handling_is_percentage) {
        this.ratecard.internet_handling_fee =
          this.ratecard.rc_total_amount * (amount / 100);
      } else this.ratecard.internet_handling_fee = amount;
    },
    OnInternethandlingSwitchHandler: function (event) {
      this.internet_handling_is_percentage = event;
      if (event) {
        this.ratecard.internet_handling_fee = Number.isNaN(
          this.ratecard.rc_total_amount
        )
          ? 0
          : this.ratecard.rc_total_amount *
            (this.ratecard.internet_handling_fee / 100);
      } else {
        this.ratecard.internet_handling_fee = Number.isNaN(
          this.ratecard.rc_total_amount
        )
          ? 0
          : (this.ratecard.internet_handling_fee /
              this.ratecard.rc_total_amount) *
            100;
      }
      this.$forceUpdate();
    },
    onChangeRatecardAmount: function (event) {
      this.cinemaChargesCalculation();
    },
    cinemaChargesCalculation: function () {
      if (String(this.ratecard.rc_amount).length > 0) {
        //Setup the initial value of net and total
        this.ratecard.rc_net_amount = parseFloat(this.ratecard.rc_amount);
        this.ratecard.rc_total_amount = parseFloat(this.ratecard.rc_amount);
        if (this.ratecard.rc_is_active_inclusivtax === "N") {
          //if percentage, create the cinema charge on top of the initial ratecard input
          this.cinemaChargesList.map((x, index) => {
            if (x.pas_is_percentage === "Y") {
              // x.cinemacharges = parseFloat(
              //   (parseFloat(this.ratecard.rc_amount) *
              //     parseFloat(x.pas_charge_value)) /
              //     100
              // ).toFixed(this.MIN_FRACTION_DIGITS);

              let tempVal =
                Math.round(this.ratecard.rc_amount * x.pas_charge_value * 100) /
                100;
              x.cinemacharges = tempVal / 100;
            }

            console.log("x.cinemacharges", x.cinemacharges);
            //create the sum assuming total is excluding taxes
            if (x.pas_is_rebate == "N") {
              x.extraChargesSum = parseFloat(
                parseFloat(x.extraChargesSum) + parseFloat(x.cinemacharges)
              ).toFixed(this.MIN_FRACTION_DIGITS);
            } else {
              x.extraChargesSum = parseFloat(
                parseFloat(x.extraChargesSum) - parseFloat(x.cinemacharges)
              ).toFixed(this.MIN_FRACTION_DIGITS);
            }
            x.extraChargesSum = parseFloat(
              parseFloat(x.extraChargesSum) + parseFloat(x.cinemacharges)
            ).toFixed(this.MIN_FRACTION_DIGITS);

            //add the cinema charge to the net amount to create total
            this.calculateNetAmount(x, "Plus");
          });
        } else if (this.ratecard.rc_is_active_inclusivtax === "Y") {
          var t = this.ratecard.rc_total_amount,
            grossAmount = this.ratecard.rc_total_amount;
          var k = 0,
            sumFixedTaxable = 0,
            w = 0,
            sumFixedRebate = 0,
            v = 0,
            sumFixedTax = 0,
            y = 0,
            sumPercentageTaxable = 0,
            z = 0,
            sumPercentageRebate = 0,
            a = 0,
            sumPercentageTax = 0;
          //handle rebate not percentage
          //assumption, if taxable is N, then it is a tax
          this.cinemaChargesList.map((x, index) => {
            if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "Y" &&
              x.pas_is_rebate == "N"
            ) {
              k += x.pas_charge_value;
            } else if (x.pas_is_percentage === "N" && x.pas_is_rebate == "Y") {
              //rebate does not have tax
              w += x.pas_charge_value;
            } else if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "N" &&
              x.pas_is_rebate == "N"
            ) {
              v += x.pas_charge_value;
            } else if (
              x.pas_is_percentage === "Y" &&
              x.pas_is_taxable === "Y" &&
              x.pas_is_rebate == "N"
            ) {
              y += x.pas_charge_value;
            } else if (x.pas_is_percentage === "Y" && x.pas_is_rebate == "Y") {
              //rebate does not have tax
              z += x.pas_charge_value;
            } else if (
              x.pas_is_percentage === "Y" &&
              x.pas_is_taxable === "N" &&
              x.pas_is_rebate == "N"
            ) {
              a += x.pas_charge_value;
            }
          });
          sumFixedTaxable = k;
          sumFixedRebate = w;
          sumFixedTax = v;
          sumPercentageTaxable = y;
          sumPercentageRebate = z;
          sumPercentageTax = a;
          this.totalTaxPercentage = sumPercentageTax;
          //  1000000 + 0     - 0     + 0      -  0      - 0       10000 + 100*8
          // console.log(t,k,w,v,y,z,a, 10000*t + 10000*w -10000*v + 100*k*z -100*k*a -10000*k,10000 + y*a -z*y + 100*y + 100*a -100*z)
          this.ratecard.rc_net_amount =
            (10000 * t +
              10000 * w -
              10000 * v +
              100 * k * z -
              100 * k * a -
              10000 * k) /
            (10000 + y * a - z * y + 100 * y + 100 * a - 100 * z);
          w = 0;
          z = 0;
          let netAmountWithoutRebate =
            (10000 * t +
              10000 * w -
              10000 * v +
              100 * k * z -
              100 * k * a -
              10000 * k) /
            (10000 + y * a - z * y + 100 * y + 100 * a - 100 * z);
          console.log("test", netAmountWithoutRebate);
          // console.log(netAmount)
          console.log(
            "1 this.ratecard.rc_net_amount",
            this.ratecard.rc_net_amount
          );
          // let temp_cinemaChargesList = this.cinemaChargesList
          // this.cinemaChargesList=[];

          this.cinemaChargesList.map((x, index) => {
            if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "Y" &&
              x.pas_is_rebate == "N"
            ) {
              x.cinemacharges = parseFloat(x.pas_charge_value).toFixed(3);
            } else if (x.pas_is_percentage === "N" && x.pas_is_rebate == "Y") {
              //rebate does not have tax
              x.cinemacharges = parseFloat(x.pas_charge_value).toFixed(3);
            } else if (
              x.pas_is_percentage === "N" &&
              x.pas_is_taxable === "N" &&
              x.pas_is_rebate == "N"
            ) {
              x.cinemacharges = parseFloat(x.pas_charge_value).toFixed(3);
            } else if (
              x.pas_is_percentage === "Y" &&
              x.pas_is_taxable === "Y" &&
              x.pas_is_rebate == "N"
            ) {
              // x.cinemacharges = parseFloat(
              //   (x.pas_charge_value * this.ratecard.rc_net_amount) / 100
              // ).toFixed(3);
              let tempVal =
                Math.round(
                  x.pas_charge_value * this.ratecard.rc_net_amount * 100
                ) / 100;
              x.cinemacharges = tempVal / 100;
              console.log("x.cinemacharges 1009", x.cinemacharges);
            } else if (x.pas_is_percentage === "Y" && x.pas_is_rebate == "Y") {
              //rebate does not have tax
              // x.cinemacharges = parseFloat(
              //   (x.pas_charge_value * this.ratecard.rc_net_amount) / 100
              // ).toFixed(3);
              let tempVal =
                Math.round(
                  x.pas_charge_value * this.ratecard.rc_net_amount * 100
                ) / 100;
              x.cinemacharges = tempVal / 100;
              console.log("x.cinemacharges 1015", x.cinemacharges);
              // this.$set(this.cinemaChargesList, index, x)
              // console.log(x.cinemacharges, 'x2',this.ratecard.rc_net_amount,'x1',x, (x.pas_charge_value * this.ratecard.rc_net_amount) / 100, parseFloat(
              //   (x.pas_charge_value * this.ratecard.rc_net_amount) / 100
              // ).toFixed(this.MIN_FRACTION_DIGITS),parseFloat(
              //   (x.pas_charge_value * this.ratecard.rc_net_amount) / 100
              // ))
            } else if (
              x.pas_is_percentage === "Y" &&
              x.pas_is_taxable === "N" &&
              x.pas_is_rebate == "N"
            ) {
              // x.cinemacharges = parseFloat(
              //   (x.pas_charge_value * this.ratecard.rc_net_amount) / 100
              // ).toFixed(3);
              let tempVal =
                Math.round(
                  x.pas_charge_value * this.ratecard.rc_net_amount * 100
                ) / 100;
              x.cinemacharges = tempVal / 100;
              console.log("x.cinemacharges 1030", x.cinemacharges);
            }
            // console.log(sumPercentageRebate)
            // if (sumPercentageRebate > 0) {
            //   if (x.pas_is_percentage === "Y" && x.pas_is_rebate == "Y") {
            //     //rebate does not have tax
            //     x.cinemacharges = parseFloat(
            //       (x.pas_charge_value * netAmountWithoutRebate) / 100
            //     ).toFixed(this.MIN_FRACTION_DIGITS);
            //   } else if (
            //     x.pas_is_percentage === "Y" &&
            //     x.pas_is_taxable === "N" &&
            //     x.pas_is_rebate == "N"
            //   ) {
            //     x.cinemacharges = parseFloat(
            //       (x.pas_charge_value * netAmountWithoutRebate) / 100
            //     ).toFixed(this.MIN_FRACTION_DIGITS);
            //   }
            // }
            // this.cinemaChargesList.push(x)
          });
          console.log("cinemaChargesList", this.cinemaChargesList);
          //  this.cinemaChargesList = temp_cinemaChargesList
          // this.$forceUpdate();  // Notice we have to use a $ here
        }
      }
    },
    cinemaChargesCalculationold1: function () {
      if (String(this.ratecard.rc_amount).length > 0) {
        //Setup the initial value of net and total
        this.ratecard.rc_net_amount = parseFloat(this.ratecard.rc_amount);
        this.ratecard.rc_total_amount = parseFloat(this.ratecard.rc_amount);
        console.log("this.cinemaChargesList1", this.cinemaChargesList);
        let extraChargesSum = this.ratecard.rc_net_amount;
        this.cinemaChargesList.map((x, index) => {
          x.extraChargesSum = 0;
          //switch based on which will change, the net or the total
          if (this.ratecard.rc_is_active_inclusivtax === "N") {
            //if percentage, create the cinema charge on top of the initial ratecard input
            if (x.pas_is_percentage === "Y") {
              x.cinemacharges = parseFloat(
                (parseFloat(this.ratecard.rc_amount) *
                  parseFloat(x.pas_charge_value)) /
                  100
              ).toFixed(this.MIN_FRACTION_DIGITS);
            }
            //create the sum assuming total is excluding taxes
            if (x.pas_is_rebate == "N") {
              x.extraChargesSum = parseFloat(
                parseFloat(extraChargesSum) + parseFloat(x.cinemacharges)
              ).toFixed(this.MIN_FRACTION_DIGITS);
            } else {
              x.extraChargesSum = parseFloat(
                parseFloat(extraChargesSum) - parseFloat(x.cinemacharges)
              ).toFixed(this.MIN_FRACTION_DIGITS);
            }
            extraChargesSum = parseFloat(
              parseFloat(extraChargesSum) + parseFloat(x.cinemacharges)
            ).toFixed(this.MIN_FRACTION_DIGITS);

            //add the cinema charge to the net amount to create total
            this.calculateNetAmount(x, "Plus");
          } else if (this.ratecard.rc_is_active_inclusivtax === "Y") {
            //if total rate is inclusive of charges
            if (x.pas_is_percentage === "Y") {
              // 118  18
              // 10   x
              // x = 10 * 18
              //       118
              //  x =  10 * (9/ 100)
              //       (109/100)
              // x.cinemacharges = parseFloat(
              //   (this.ratecard.rc_amount*x.pas_charge_value)/(100+x.pas_charge_value)
              // ).toFixed(this.MIN_FRACTION_DIGITS)
              x.cinemacharges = parseFloat(
                ((parseFloat(this.ratecard.rc_amount) /
                  this.calculatePercentageCharge()) *
                  parseFloat(x.pas_charge_value)) /
                  100
              ).toFixed(this.MIN_FRACTION_DIGITS);
            }
            //remove from the total and calculate the net
            console.log("t6", index, x.cinemacharges);
            this.calculateNetAmount(x, "Minus");
          }

          //if fixed, calculate tax rate
          if (x.pas_is_percentage === "N" && x.pas_is_taxable === "Y") {
            // 118  18
            // 10   x
            let totalTaxPercentage = this.calculateTotalTaxPercentage();
            console.log("test", totalTaxPercentage, x.pas_charge_value);
            x.cinemacharges =
              (x.pas_charge_value * totalTaxPercentage) /
              (100 + totalTaxPercentage);
            console.log("test2", x.cinemacharges);
            x.cinemacharges = parseFloat(x.cinemacharges).toFixed(this.MIN_FRACTION_DIGITS);
            // x.cinemacharges = parseFloat(
            //     ((parseFloat(this.ratecard.rc_amount) /
            //       this.calculatePercentageCharge(x)) *
            //       parseFloat(x.pas_charge_value)) /
            //       100
            //   ).toFixed(this.MIN_FRACTION_DIGITS);
            // x.cinemacharges = parseFloat(
            //   parseFloat(x.pas_charge_value) * this.calculateTaxableCharge()
            // ).toFixed(this.MIN_FRACTION_DIGITS);
            // console.log('t4', index)
            // this.calculateNetAmount(x, "Minus");
            //if fixed and not taxable
          } else if (x.pas_is_percentage === "N" && x.pas_is_taxable === "N") {
            x.cinemacharges = parseFloat(x.pas_charge_value).toFixed(this.MIN_FRACTION_DIGITS);
            console.log("t5", index);
            this.calculateNetAmount(x, "Minus");
          }
          console.log(
            "x.extraChargesSum ",
            x.extraChargesSum,
            x.cinemacharges,
            extraChargesSum
          );

          console.log(
            "x.extraChargesSum1 ",
            x.extraChargesSum,
            x.cinemacharges,
            extraChargesSum
          );

          return x;
        });
        console.log("this.cinemaChargesList2", this.cinemaChargesList);

        this.$forceUpdate();
      }
    },
    calculatePercentageCharge: function () {
      let finalvalue = 1;
      // console.log("this.cinemaChargesList :", this.cinemaChargesList);
      this.cinemaChargesList.map((x) => {
        if (x.pas_is_percentage === "Y") {
          // console.log("x.pas_charge_value :", x.pas_charge_value);
          finalvalue += parseFloat(x.pas_charge_value) / 100;
        }
        console.log("finalvalue :>> ", finalvalue, x);
      });
      return finalvalue;
    },
    calculateNetAmount: function (x, equation) {
      if (equation === "Plus") {
        if (x.pas_is_percentage === "Y" && x.pas_is_rebate === "N") {
          this.ratecard.rc_total_amount += x.cinemacharges;
        } else if (x.pas_is_percentage === "Y" && x.pas_is_rebate === "Y") {
          this.ratecard.rc_total_amount =
            this.ratecard.rc_total_amount - x.cinemacharges;
        } else if (
          x.pas_is_percentage === "N" &&
          x.pas_is_taxable === "N" &&
          x.pas_is_rebate == "N"
        ) {
          this.ratecard.rc_total_amount += x.pas_charge_value;
        } else if (
          x.pas_is_percentage === "N" &&
          x.pas_is_taxable === "N" &&
          x.pas_is_rebate == "Y"
        ) {
          this.ratecard.rc_total_amount =
            this.ratecard.rc_total_amount - x.pas_charge_value;
        } else if (
          x.pas_is_percentage === "N" &&
          x.pas_is_taxable === "Y" &&
          x.pas_is_rebate == "N"
        ) {
          this.ratecard.rc_total_amount += x.pas_charge_value;
        }
      } else if (equation === "Minus") {
        // console.log('x :', x);
        // console.log('this.ratecard.rc_net_amount :', this.ratecard.rc_net_amount);
        // console.log("x.ct_name :", x.ct_name);
        // console.log("x.pas_charge_value :", x.pas_charge_value);
        // console.log("x.cinemacharges :", x.cinemacharges);
        // console.log(
        //   "this.ratecard.rc_net_amount :",
        //   this.ratecard.rc_net_amount
        // );

        if (x.pas_is_percentage === "Y" && x.pas_is_rebate == "N") {
          console.log("if :", x.cinemacharges);
          this.ratecard.rc_net_amount -=
            Math.round(x.cinemacharges * 100) / 100;
        } else if (x.pas_is_percentage === "Y" && x.pas_is_rebate == "Y") {
          this.ratecard.rc_net_amount =
            this.ratecard.rc_net_amount +
            Math.round(x.cinemacharges * 100) / 100;
        } else if (
          x.pas_is_percentage === "N" &&
          x.pas_is_taxable === "N" &&
          x.pas_is_overnabove === "N" &&
          x.pas_is_rebate === "N"
        ) {
          this.ratecard.rc_net_amount -=
            Math.round(x.pas_charge_value * 100) / 100;
        } else if (
          x.pas_is_percentage === "N" &&
          x.pas_is_taxable === "Y" &&
          x.pas_is_rebate === "N"
        ) {
          console.log("test3", x.pas_charge_value);
          this.ratecard.rc_net_amount -=
            Math.round(x.pas_charge_value * 100) / 100;
        } else if (
          x.pas_is_percentage === "N" &&
          x.pas_is_taxable === "N" &&
          x.pas_is_overnabove === "N" &&
          x.pas_is_rebate === "Y"
        ) {
          // console.log("else if :", x.pas_charge_value);
          this.ratecard.rc_net_amount =
            this.ratecard.rc_net_amount +
            Math.round(x.pas_charge_value * 100) / 100;
        }
        // NEW
        // else if (x.pas_is_overnabove === "Y") {
        //   console.log("else if last :", x.pas_charge_value);
        //   this.ratecard.rc_net_amount += parseFloat(x.pas_charge_value);
        // }
      }
    },
    calculateTotalTaxPercentage: function () {
      let totalTaxPercentage = 0;
      this.cinemaChargesList.map((x) => {
        //Pick only items that are taxable
        if (x.pas_is_percentage === "Y" && x.pas_is_taxable === "Y") {
          totalTaxPercentage += parseFloat(x.pas_charge_value) / 100;
        }
      });
      return totalTaxPercentage * 100;
    },
    calculateTaxableCharge: function () {
      let finalvalue = 1;
      this.cinemaChargesList.map((x) => {
        //Pick only items that are taxable
        if (x.pas_is_percentage === "Y") {
          finalvalue -= parseFloat(x.pas_charge_value) / 100;
        }
      });
      return finalvalue;
    },
    __cinemaChargesCalculationOld: function () {
      this.ratecard.rc_net_amount = parseFloat(this.ratecard.rc_amount);
      // console.log("this.ratecard.rc_amount :", this.ratecard.rc_amount);
      // console.log("this.cinemaChargesList :", this.cinemaChargesList);
      // console.log("this.ratecard.rc_is_active_inclusivtax :", this.ratecard.rc_is_active_inclusivtax);
      this.cinemaChargesList.map((x) => {
        if (this.ratecard.rc_is_active_inclusivtax === "N") {
          if (x.pas_is_percentage === "Y") {
            x.cinemacharges =
              (parseFloat(this.ratecard.rc_amount) *
                parseFloat(x.pas_charge_value)) /
              100;
          } else if (x.pas_is_percentage !== "Y") {
            x.cinemacharges = x.pas_charge_value;
          }
          // console.log("x.cinemacharges :", x.cinemacharges);
          this.ratecard.rc_net_amount += parseFloat(x.cinemacharges);
        } else if (this.ratecard.rc_is_active_inclusivtax === "Y") {
          if (x.pas_is_percentage === "Y") {
            x.cinemacharges =
              (parseFloat(this.ratecard.rc_amount) *
                parseFloat(x.pas_charge_value)) /
              100;
          } else if (x.pas_is_percentage !== "Y") {
            x.cinemacharges = x.pas_charge_value;
          }
          // console.log("inclusivoftax x.cinemacharges :", x.cinemacharges);
        }
        return x;
      });
      this.$forceUpdate();
    },
    OnFinalSubmit: function (redirect) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (
            this.ratecard.rc_amount === "0" &&
            !this.accepted_zero_rate_card_popup
          ) {
            this.$bvModal.show("zeroRateCardAmountModal");
            return;
          }
          if (
            this.ratecard.item_id &&
            this.ratecard.item_id == null &&
            this.ratecard.item_is_compulsory === true
          ) {
            return;
          } else {
            this.btenable = true;
            let chargeSettingsSubmit = this.cinemaChargesList;
            //total taxable amount
            let totalTaxableAmount = this.ratecard.rc_net_amount;
            chargeSettingsSubmit.map((x) => {
              console.log("totalTaxableAmount", totalTaxableAmount);
              if (x.pas_is_percentage === "Y" && x.pas_is_taxable === "Y") {
                totalTaxableAmount =
                  +parseFloat(totalTaxableAmount).toPrecision(3) +
                  +parseFloat(
                    (x.pas_charge_value * this.ratecard.rc_net_amount) / 100
                  ).toPrecision(3);
                console.log("totalTaxableAmount1", totalTaxableAmount);
              } else if (
                x.pas_is_percentage === "N" &&
                x.pas_is_taxable === "Y"
              ) {
                totalTaxableAmount =
                  parseFloat(totalTaxableAmount) +
                  parseFloat(x.pas_charge_value).toPrecision(3);
              }
            });
            // console.log("totalTaxableAmount",totalTaxableAmount)
            // console.log("chargeSettingsSubmit",chargeSettingsSubmit)

            chargeSettingsSubmit = chargeSettingsSubmit.map((x) => {
              if (x.pas_is_percentage === "Y" && x.pas_is_taxable === "N") {
                // x.cinemacharges = parseFloat(
                //   (x.pas_charge_value * totalTaxableAmount) / 100
                // ).toFixed(3);

                let tempVal =
                  Math.round(x.pas_charge_value * totalTaxableAmount * 100) /
                  100;
                x.cinemacharges = tempVal / 100;
              }
              return x;
            });

            let payload = {
              ...this.ratecard,
              rc_amount: parseFloat(this.ratecard.rc_amount),
              rc_net_amount: parseFloat(this.ratecard.rc_net_amount),
              rc_pas_setting_name: this.selectedChargeSettingName,
              cinemaChargesList: chargeSettingsSubmit,
            };
            CinemasService.AddRatecard(payload)
              .then((response) => {
                this.btenable = false;
                const { data } = response;
                if (data && data.status) {
                  this.resetForm();
                  if (redirect) {
                    this.$router.push({
                      path: "/cinema-manager/rateCard",
                    });
                  }
                  this.submitted = false;
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError); //message
          }
        }
      });
    },
    // Saif
  },
};
</script>

<style>
.totalborder {
  border-top: 1px dotted grey;
  padding-top: 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/RatecardComponents/addRateCard.vue